
<mat-dialog-content style="text-align: center" >
  <h3 style="font-weight: 500">{{data.header_msg}}</h3>
  <p>{{data.header_msg_description}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close>{{data.cancel_action}}</button>
  <button mat-flat-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>{{data.ok_action}}</button>
</mat-dialog-actions>
